/**
The main entry point for the Kits Landing Page.

Referenced by the collection.kits.liquid template.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import './scss/templates/collection-kits.scss';
import CollectionKits from './apps/collection-kits/CollectionKits';
import OVApp from './utils/OVContext';
import { jsx as _jsx } from "react/jsx-runtime";
var COLLECTION_ID = window.OV.COLLECTION_ID;
var liquidRoot = '.collection-kits-loading';

var init = function init() {
  var main = document.getElementById('collection');
  var kitTitleEl = main.querySelector("".concat(liquidRoot, "__title"));
  var kitDescriptionEl = main.querySelector("".concat(liquidRoot, "__description"));
  var kitsGridElms = main.querySelectorAll("".concat(liquidRoot, "__kit"));
  var kitDescription = kitDescriptionEl ? kitDescriptionEl.innerText : '';
  var kitTitle = kitTitleEl ? kitTitleEl.innerText : '';
  ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
    children: /*#__PURE__*/_jsx(CollectionKits, {
      kitDescription: kitDescription,
      kitsGrid: kitsGridElms,
      kitTitle: kitTitle,
      shopifyId: COLLECTION_ID
    })
  }), document.getElementById('collection'));
};

init();